import type { LucideIcon } from 'lucide-react';
import type { DiagnosticInsight } from '../../types/result';
import { SectionHeading } from './SectionHeading';

interface InsightListProps {
  title: string;
  icon: LucideIcon;
  insights: readonly DiagnosticInsight[];
  emptyText: string;
}

/** Liste für Stärken bzw. Engpässe (Abschnitt 18). */
export function InsightList({ title, icon, insights, emptyText }: InsightListProps) {
  return (
    <section className="stack">
      <SectionHeading icon={icon}>{title}</SectionHeading>
      {insights.length === 0 ? (
        <p className="card card--muted">{emptyText}</p>
      ) : (
        <div className="cluster-grid">
          {insights.map((insight) => (
            <article key={insight.id} className="card insight-card">
              <h3>{insight.title}</h3>
              <p>{insight.summary}</p>
              <p>{insight.detail}</p>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}
